import { useMemo } from "react";
import { Link, useNavigate, useParams } from "react-router";

import { Typography, useMediaQuery } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";
import TilleyDataGrid from "components/shared/DataGrid/TilleyDataGrid";
import { formatNumber, formatPercentage } from "utility/formatters";

import { NavigateIcon } from "../../Icons/Icons";

export default function ArcPlcProducerFarmBaseAcreDataTable({
  producerFarmBaseAcres,
  isLoading,
  pageSizes = [5, 10, 25, 50, 100],
  rowHeight = 80,
}) {
  const navigate = useNavigate();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("lg"), { noSsr: true });

  const { crop_year } = useParams();

  const COLUMNS_PRODUCERFARMBASEACRES = useMemo(
    () => [
      {
        field: "commodity_name",
        headerName: "Commodity",
        flex: 1,
        renderCell: (params) => (
          <Typography
            color="primary"
            component={Link}
            to={`/arcplc/${crop_year}/${params.row.location_state_name}/${params.row.location_county_name}/${params.row.commodity_name}`}
          >
            {params.value}
          </Typography>
        ),
      },
      {
        field: "base_acreage",
        headerName: "Acres",
        flex: 1,
      },
      {
        field: "plc_yield_weighted",
        headerName: "PLC Yield (avg)",
        flex: 1,
        valueFormatter: (value) => (value ? formatNumber(value, 0) : ""),
      },
      {
        field: "share_percent_weighted",
        headerName: "Share % (avg)",
        flex: 1,
        valueFormatter: (value) => (value ? formatPercentage(value, 0) : ""),
      },
      {
        field: "actions",
        headerName: "Actions",
        type: "actions",
        headerAlign: "right",
        align: "right",
        width: 100,
        sortable: false,
        getActions: (params) => {
          return [
            <GridActionsCellItem
              key="view"
              icon={<NavigateIcon />}
              label="View"
              onClick={() => {
                navigate(
                  `/arcplc/${crop_year}/${params.row.location_state_name}/${params.row.location_county_name}/${params.row.commodity_name}`
                );
              }}
            />,
          ];
        },
        flex: 0,
      },
    ],
    [navigate, crop_year]
  );

  return (
    <TilleyDataGrid
      rows={producerFarmBaseAcres || []}
      columns={COLUMNS_PRODUCERFARMBASEACRES}
      pageSizeOptions={pageSizes}
      defaultPageSize={isMobile ? 5 : 10}
      gridKey="arcplc-producer-farm-base-acres"
      getRowId={(row) => row.id}
      rowHeight={rowHeight}
      isLoading={isLoading}
      sx={{ maxWidth: "99%", boxSizing: "border-box" }}
    />
  );
}
